<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            ref="gofixTable">
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal :no-close-on-backdrop="true"
                modal-class="modal-create modal-audit-trail"
                title="Detail Log"
                hide-footer :centered="true"
                ref="modal-create-item"
                v-model="modals.detail.open">
                <div class="auditTrailDetail" v-if="modals.detail.data">
                    <div class="field">
                        <span class="title"><b>Title:</b></span>
                        <span class="value">{{modals.detail.data.title}}</span>
                    </div>
                    <div class="field">
                        <span class="title"><b>Description:</b></span>
                        <span class="value">{{modals.detail.data.description}}</span>
                    </div>
                    <div class="field">
                        <span class="title"><b>User:</b></span>
                        <span class="value">{{modals.detail.data.email || "Guest"}}</span>
                    </div>
                    <div class="field">
                        <span class="title"><b>Url:</b></span>
                        <span class="value">{{modals.detail.data.url}}</span>
                    </div>
                    <div class="field">
                        <span class="title"><b>Method:</b></span>
                        <span class="value">{{modals.detail.data.method}}</span>
                    </div>
                    <div class="field">
                        <span class="title"><b>IP:</b></span>
                        <span class="value">{{modals.detail.data.ip}}</span>
                    </div>
                    <div class="field">
                        <span class="title"><b>Browse Engine:</b></span>
                        <span class="value">{{modals.detail.data.browse_engine}}</span>
                    </div>
                    <div class="field">
                        <span class="title"><b>Time:</b></span>
                        <span class="value">{{modals.detail.data.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}</span>
                    </div>
                    <div class="field">
                        <span class="title mb-1"><b>Request Data:</b></span>
                        <json-viewer
                                :value="modals.detail.data.request_data"
                                copyable
                                boxed
                                sort></json-viewer>
                    </div>
                </div>
                <div>
                    <b-button-group class="text-right d-block pr-3">
                        <gofix-button label="CLOSE" @click="modals.detail.open = false" noBorder dark></gofix-button>
                    </b-button-group>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    import JsonViewer from 'vue-json-viewer';

    export default {
        name: 'audit-trail',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['audit_trail']));
            return {
                tableConfig:{
                    name: 'account-audit-trails',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport:false,
                        tableExport:false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                    // fields: [
                    //     {
                    //         key: 'created_at',
                    //         label: 'Time',
                    //         placeholder: 'search',
                    //         isActive: 1,
                    //         isFilter: true,
                    //         with:150,
                    //         thStyle: "width:150px",
                    //         sorting: true,
                    //     },
                    //     {
                    //         key: 'title',
                    //         label: 'Title',
                    //         placeholder: 'search',
                    //         isActive: 1,
                    //         isFilter: true,
                    //         with:250,
                    //         thStyle: "width:250px",
                    //         sorting: true,
                    //     },
                    //     {
                    //         key: 'method',
                    //         label: 'Method',
                    //         placeholder: 'Select',
                    //         isActive: 1,
                    //         isFilter: true,
                    //         with:150,
                    //         thStyle: "width:150px",
                    //         sorting: true,
                    //     },
                    //     {
                    //         key: 'url',
                    //         label: 'URL',
                    //         placeholder: 'search',
                    //         isActive: 1,
                    //         isFilter: true,
                    //         with:250,
                    //         thStyle: "width:250px",
                    //         sorting: true,
                    //     },
                    //     {
                    //         key: 'ip',
                    //         label: 'IP',
                    //         placeholder: 'search',
                    //         isActive: 1,
                    //         isFilter: true,
                    //         with:150,
                    //         thStyle: "width:150px",
                    //         sorting: true,
                    //     },
                    //     {
                    //         key: 'email',
                    //         label: 'User',
                    //         placeholder: 'search',
                    //         isActive: 1,
                    //         isFilter: true,
                    //         with:250,
                    //         thStyle: "width:250px",
                    //         sorting: true,
                    //     },
                    //     {
                    //         key: 'browse_engine',
                    //         label: 'Browse Engine',
                    //         placeholder: 'search',
                    //         isActive: 1,
                    //         isFilter: true,
                    //         with:null,
                    //         thStyle: "width:auto",
                    //         sorting: true,
                    //     }
                    // ],
                    dataSelect: {
                        method: {
                            value: [
                                {value: 'POST', text: 'POST'},
                                {value: 'PUT', text: 'PUT'},
                                {value: 'DELETE', text: 'DELETE'},
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    },
                },
                tableItems: [],
                modals:{
                    detail: {
                        open: false,
                        loading: false,
                        data: null,
                    }
                }
            }
        },
        components: {JsonViewer},
        created () {

        },

        methods:{
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("AuditTrailController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the maintenance standard", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                this.modals.detail.open = true;
                this.modals.detail.data = item;
                this.modals.detail.data.request_data = JSON.parse(item.request_data);
            },
            /*---------------*/
        }
    }
</script>
